import { ButtonGroup, IButtonGroupProps, Sizes } from "@sede-enterprise/shell-ds-react-framework"
import { DefaultRadioContainer } from "./ToogleRadio.styled";
import { on } from "events";

export interface IToggleProps {
  showOrHide: string;
  onChange: () => void;
}

export const ToogleRadio = ({ showOrHide, onChange }: IToggleProps) => {
  const buttonGroupArgs : IButtonGroupProps = {
    type: "radio",
    size: Sizes.ExtraSmall,
    onChange: onChange,
    selectedKey: showOrHide,
    items: [
      {
        label: "Show",
        value: "show"
      },
      {
        label: "Hide",
        value: "hide"
      }
    ]
  }
  return (
    <DefaultRadioContainer data-testid="ToggleRadio" >
      <ButtonGroup {...buttonGroupArgs} />
    </DefaultRadioContainer>
  )
}

export default ToogleRadio;